export const VALUATION_INPUT_CLS = 'w-full px-4 py-4 rounded-md border-2 border-[#143160] focus:border-gold-400 focus:outline-none text-lg font-semibold';

export const VALUATION_BUTTON_CLS = 'w-full text-white h-16 text-xl font-black uppercase tracking-wide hover:scale-105 transition-all relative overflow-hidden rounded-md border-2 border-gold-400/50 disabled:hover:scale-100';

export const VALUATION_BUTTON_STYLE = {
  background: 'linear-gradient(135deg, #143160 0%, #1E4A86 100%)',
  boxShadow: '0 0 30px rgba(14,58,101,0.4), 0 8px 24px rgba(0,0,0,0.3)',
};
